import type { Language } from '../content';
import { whatsAppLink } from '../services/whatsapp';

/**
 * Fixed, always-visible WhatsApp call-to-action on the right edge. Clicking opens WhatsApp
 * (app or web) with a pre-filled greeting to the sales line — free, no WhatsApp Business account.
 */
export function WhatsAppFab({ language }: { language: Language }) {
  const label = language === 'ar' ? 'تواصل عبر واتساب' : 'Chat on WhatsApp';
  const greeting =
    language === 'ar'
      ? 'مرحبًا، أريد الاستفسار عن نظام إدارة مختبرات الأسنان.'
      : 'Hello, I would like to ask about the Dental Lab System.';

  return (
    <a
      className="wa-fab"
      href={whatsAppLink(greeting)}
      target="_blank"
      rel="noreferrer noopener"
      aria-label={label}
      title={label}
    >
      <span className="wa-fab__pulse" aria-hidden="true" />
      <svg className="wa-fab__icon" viewBox="0 0 32 32" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M16.02 3.2c-7.06 0-12.8 5.73-12.8 12.79 0 2.25.59 4.45 1.71 6.39L3.2 28.8l6.6-1.7a12.78 12.78 0 0 0 6.2 1.58h.01c7.05 0 12.79-5.73 12.79-12.79 0-3.42-1.33-6.63-3.75-9.05a12.7 12.7 0 0 0-9.03-3.64Zm0 23.4h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.92 1.03 1.05-3.82-.25-.4a10.6 10.6 0 0 1-1.62-5.64c0-5.87 4.78-10.64 10.65-10.64 2.84 0 5.51 1.11 7.52 3.12a10.56 10.56 0 0 1 3.11 7.53c0 5.87-4.78 10.64-10.64 10.64Zm5.84-7.97c-.32-.16-1.89-.93-2.18-1.04-.29-.11-.5-.16-.72.16-.21.32-.82 1.04-1.01 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.73-.99-2.37-.26-.62-.52-.54-.72-.55l-.61-.01c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.66 0 1.57 1.14 3.08 1.3 3.29.16.21 2.25 3.43 5.45 4.81.76.33 1.35.52 1.82.67.76.24 1.46.21 2.01.13.61-.09 1.89-.77 2.16-1.52.27-.75.27-1.39.19-1.52-.08-.13-.29-.21-.61-.37Z"
        />
      </svg>
      <span className="wa-fab__label">{label}</span>
    </a>
  );
}
